<template>
  <div class="cmp-custom-panel">
    <div class="cmp-toolbar">
      <div class="cmp-title">Modifica i permessi per la struttura selezionata</div>

      <button
        v-if="copyPermissionButtonIsActive"
        type="button"
        class="btn btn-primary"
        @click="() => (showCopyPermissions = !showCopyPermissions)"
      >
        Copia permessi
      </button>
    </div>
    <copy-permissions-modal
      @modalClosed="() => (showCopyPermissions = false)"
      v-if="showCopyPermissions"
      :resources="resources"
      :current-resource="selectedResource"
      :roles="roles"
    />
  </div>
</template>
<script>
import copyPermissionsModal from './copyPermissions/copyPermissionsModal';

export default {
  name: 'permissionsToolbar',
  props: {
    resources: { type: Object, required: true },
    selectedResource: { type: String },
    roles: { type: Object, required: true },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    copyPermissionButtonIsActive() {
      return this.canEdit && Object.keys(this.resources).length && Object.keys(this.roles).length;
    },
  },
  data: () => ({
    showCopyPermissions: false,
  }),
  components: {
    copyPermissionsModal,
  },
};
</script>
<style lang="scss" scoped>
.cmp-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cmp-title {
  font-size: 20px;
  font-weight: 200;
  margin: 15px 0 25px;
}
</style>
